/* eslint-disable max-lines */
import React, { forwardRef, useState } from 'react';

import moment from 'moment';
import { useRecoilValue } from 'recoil';

import { ia } from 'lib/helpers/utility';

import DocumentModal from 'components/shared/DocumentEditor/DocumentModal';
import state from 'components/state';

import ContactsModal from '../../../Contacts/components/ContactsModal';
import CoverPages from '../../CoverPages/CoverPages';

import DocsModal from './components/DocsModal/DocsModal';
import SendFaxFiles from './components/SendFaxFiles';
import SendFaxForm from './components/SendFaxForm';
import useSendFaxFormik from './lib/useSendFaxFormik';

const SendFax = forwardRef(
  (
    {
      fax,
      setLoading = () => {},
      setSendFaxModalVisible = () => {},
      documents,
      clearSelection = () => {}
    },
    ref
  ) => {
    const [contactsModalVisible, setContactsModalVisible] = useState(false);
    const [docsModalVisible, setDocsModalVisible] = useState(false);
    const [previewFaxModalVisible, setPreviewFaxModalVisible] = useState(false);
    const [fax_user, setFax_user] = useState(null);
    const user = useRecoilValue(state.userState);
    const [pdfData, setPdfData] = useState(null);
    const [resetTags, setResetTags] = useState(false);
    const [error, setError] = useState({ number: null, file: null });

    const [docsLoading, setDocsLoading] = useState(ia(documents) ? true : false);

    const formik = useSendFaxFormik({
      fax,
      setLoading,
      setSendFaxModalVisible,
      setResetTags,
      setPdfData,
      setPreviewFaxModalVisible,
      clearSelection
    });

    const { setFieldValue, values } = formik;

    const handleSelectContacts = (contacts) => {
      setError((prev) => ({ ...prev, number: null }));
      setFieldValue('contacts', contacts);
      setContactsModalVisible(false);
    };

    const handleInsertFiles = (files) => {
      setError((prev) => ({ ...prev, file: null }));

      setFieldValue('files', [...values.files, ...files]);
      setDocsModalVisible(false);
    };

    return (
      <div className="h-full flex-1">
        <div className="flex h-full md:flex-col">
          <SendFaxForm
            resetTags={resetTags}
            formik={formik}
            setContactsModalVisible={setContactsModalVisible}
            setFax_user={setFax_user}
            ref={ref}
            error={error}
            setError={setError}
            fax={fax}
          />
          <SendFaxFiles
            setDocsModalVisible={setDocsModalVisible}
            formik={formik}
            error={error}
            setError={setError}
            docsLoading={docsLoading}
          />
        </div>
        {contactsModalVisible && (
          <ContactsModal
            {...{
              contactsModalVisible,
              setContactsModalVisible,
              handleSelectContacts,
              selectedContacts: values.contacts,
              selectOne: true
            }}
          />
        )}

        <DocsModal
          {...{
            docsModalVisible,
            setDocsModalVisible,
            handleInsertFiles,
            documents,
            loading: docsLoading,
            setLoading: setDocsLoading
          }}
        />

        {previewFaxModalVisible && (
          <DocumentModal
            src={pdfData}
            kind="fax"
            handleOpen={previewFaxModalVisible}
            handleClose={() => setPreviewFaxModalVisible(false)}
            title="Preview Fax"
          />
        )}
        <div style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}>
          <CoverPages
            {...{
              date: moment(new Date()).format('MMMM D, YYYY, h:mm A'),
              senderFax: fax_user?.fax_number,
              senderName: user?.professionalFullName,
              subject: values.subject,
              recipientFax: values.fax_numbers[0]?.fax_number || values.contacts[0]?.fax_number,
              recipientPhone: values?.contacts[0]?.phone_number || null,
              recipientName: values?.contacts[0]
                ? values.contacts[0]?.first_name + ' ' + values.contacts[0]?.last_name
                : values.deliver_to
                  ? values.deliver_to
                  : null,
              note: values.notes,
              values
            }}
          />
        </div>
      </div>
    );
  }
);

SendFax.displayName = 'SendFax';
export default SendFax;
